import { render, staticRenderFns } from "./BusSeatConfigurator.vue?vue&type=template&id=deaeae02&scoped=true&"
import script from "./BusSeatConfigurator.vue?vue&type=script&lang=js&"
export * from "./BusSeatConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./BusSeatConfigurator.vue?vue&type=style&index=0&id=deaeae02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaeae02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})
